import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";
import { toast } from "react-toastify";

export const SignUpApi = createAsyncThunk(
  "signData/signUpApi",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(endPoint.SIGNUP, {
        email: data?.email,
        password: data?.password,
        name: data?.name,
      });
      return response?.data;
    } catch (error) {
      toast.success("Email is already in use", {
        position: "top-right",
        autoClose: 2000,
        style: {
          backgroundColor: "#d0d3d4 ",
          color: "black",
          fontWeight: "bold",
        },
      });
      console.log("error", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const SignUpSlice = createSlice({
  name: "SignUpData",
  initialState: {
    SignUpData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SignUpApi.fulfilled, (state, action) => {
        state.SignUpData = action.payload;
      })
      .addCase(SignUpApi.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default SignUpSlice.reducer;
